import main from "emun.cart/checkout.htm";
import bottom from "emun.cart/checkout/checkout.bottom.htm";
import left from "emun.cart/checkout/checkout.left.htm";
import right from "emun.cart/checkout/checkout.right.htm";
import top from "emun.cart/checkout/checkout.top.htm";

export default {
  main,
  left,
  right,
  top,
  bottom,
};
